import { render, staticRenderFns } from "./SendResetPassword.vue?vue&type=template&id=f98305b2"
import script from "./SendResetPassword.vue?vue&type=script&lang=js"
export * from "./SendResetPassword.vue?vue&type=script&lang=js"
import style0 from "./SendResetPassword.vue?vue&type=style&index=0&id=f98305b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports